export default function jsonToFormData(json, parentFormData, parentKey) {
    let fd = parentFormData ? parentFormData : new FormData();
    let fdKey = ''
    for (let key in json) {
        fdKey = key;
        //Check parent key
        if (parentKey) {
            //Is a sub key
            fdKey = parentKey + '[' + key + ']';
        }
        //Check validate form
        if (isValidFormDataIterable(json[key])) {
            //Recursive
            jsonToFormData(json[key], fd, fdKey);
        } else {
            fd.append(fdKey, json[key]);
        }
    }
    return fd;
}

function isValidFormDataIterable(json) {
    if (json instanceof Array) {
        return true;
    }
    return !(json instanceof File) && !(json instanceof Blob) && (typeof json === "object" && json !== null);
}